import React from 'react';

import Card from '@mui/material/Card';
import SerialInfoCard from './SerialInfoCard';
import SerialHistoryList from './SerialHistoryList';
import SerialInfoActionCard from './SerialInfoActionCard';

import UnauthorisedAccess from '../CommonComponents/UnauthorisedAccess';
import { useLocation } from 'react-router-dom';

export default function SerialNumberHistory() {
  const location = useLocation();
  const [useType, setUseType] = React.useState(localStorage.getItem('type'));
  // console.log(location.state);
  return useType === 'technician' ? (
    <UnauthorisedAccess />
  ) : (
    <Card
      md={{
        background: 'none',
        border: 'none',
        boxShadow: 'none',
        padding: '10px',
        // width: '100%',
      }}
      xs={{ padding: 0 }}
    >
      <SerialInfoCard serialInfo={location.state} />
      <SerialHistoryList serialInfo={location.state} />
      <SerialInfoActionCard serialInfo={location.state} />
    </Card>
  );
}
